import TinySlider from 'CoreComponents/tinySlider';

if (document.querySelector('#tiny-slider')) {
  new TinySlider();
}
